var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 51.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    className: "cls-1",
    d: "M54,0H11C4.92,0,0,5.65,0,12.63V39c0,7,4.92,12.63,11,12.63H54C60.08,51.67,65,46,65,39V12.63C65,5.65,60.08,0,54,0ZM45.69,27.36,26.19,38.84a1.41,1.41,0,0,1-2-.73,2,2,0,0,1-.17-.79v-23a1.62,1.62,0,0,1,1.5-1.72,1.32,1.32,0,0,1,.69.2l19.5,11.48a1.85,1.85,0,0,1,.65,2.32,1.57,1.57,0,0,1-.65.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5b3fd5ea5391bbe5f1a143acda6a0bed.svg";
export { ForwardRef as ReactComponent };